import _extends from '../../../node_modules/@babel/runtime/helpers/esm/extends.js';
import _objectWithoutProperties from '../../../node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js';
import React__default, { useRef, useEffect } from 'react';
import PropTypes__default from 'prop-types';
import { makeStyles, Dialog, DialogTitle, Box, IconButton, DialogContent, DialogActions } from '@material-ui/core';
import { useBreakpoints } from '../../hooks/useBreakpoints.js';
import CloseIcon from '../streamline-icon/CloseIcon.js';

var _excluded = ["handleClose", "isFullScreen", "hasCloseButton", "title", "content", "actions"];
var useStyles = makeStyles(function (theme) {
  return {
    title: {
      padding: theme.spacing(1.5, 2, 1.5, 3)
    },
    actions: {
      justifyContent: "center",
      marginTop: theme.spacing(4),
      marginBottom: theme.spacing(4)
    }
  };
});
var ResponsiveDialog = function ResponsiveDialog(_ref) {
  var handleClose = _ref.handleClose,
    isFullScreen = _ref.isFullScreen,
    hasCloseButton = _ref.hasCloseButton,
    title = _ref.title,
    content = _ref.content,
    actions = _ref.actions,
    props = _objectWithoutProperties(_ref, _excluded);
  var classes = useStyles();
  var _useBreakpoints = useBreakpoints(),
    isExtraSmallScreen = _useBreakpoints.isExtraSmallScreen;
  var dialogRef = useRef(null);
  var removeTabIndex = function removeTabIndex() {
    var _dialogRef$current;
    dialogRef === null || dialogRef === void 0 || (_dialogRef$current = dialogRef.current) === null || _dialogRef$current === void 0 || _dialogRef$current.getElementsByClassName("MuiDialog-container")[0].removeAttribute("tabindex");
  };
  useEffect(function () {
    setTimeout(removeTabIndex, 1000);
  }, []);
  return /*#__PURE__*/React__default.createElement(Dialog, _extends({
    onClose: handleClose,
    fullWidth: true,
    fullScreen: isFullScreen === undefined ? isExtraSmallScreen() : isFullScreen,
    ref: dialogRef
  }, props), /*#__PURE__*/React__default.createElement(DialogTitle, {
    className: classes.title
  }, /*#__PURE__*/React__default.createElement(Box, {
    display: "flex",
    alignItems: "center"
  }, /*#__PURE__*/React__default.createElement(Box, {
    flexGrow: 1
  }, title), hasCloseButton && /*#__PURE__*/React__default.createElement(Box, null, /*#__PURE__*/React__default.createElement(IconButton, {
    onClick: handleClose
  }, /*#__PURE__*/React__default.createElement(CloseIcon, null))))), /*#__PURE__*/React__default.createElement(DialogContent, null, content), actions && /*#__PURE__*/React__default.createElement(DialogActions, {
    className: classes.actions
  }, actions));
};
ResponsiveDialog.propTypes = {
  handleClose: PropTypes__default.func,
  isFullScreen: PropTypes__default.bool,
  hasCloseButton: PropTypes__default.bool,
  title: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.element]),
  content: PropTypes__default.element,
  actions: PropTypes__default.element,
  props: PropTypes__default.any
};

export { ResponsiveDialog as default };
//# sourceMappingURL=ResponsiveDialog.js.map
